import dottie from 'dottie'
import { api } from '@/api'

const state = {
  user: {}
}

const getters = {
  user: state => {
    // __type as hint for casl based acl
    // TODO: find a better implementation with classes, objects
    state.user.__type = 'User'
    return state.user
  },
  isAdmin: state => {
    return state.user.admin
  }
}

const mutations = {
  loginFailed(state) {
    state.user = {}
    state.validUser = false
  },
  userLoggedIn(state, { user, rules }) {
    state.user = user
    state.validUser = true
  },
  userLoggedOut(state) {
    state.user = {}
    state.validUser = false
  },
  verified(state, { user }) {
    state.user = user
    state.validUser = true
  },
  verificationFailed(state) {
    state.user = {}
    state.validUser = false
  }
}

const actions = {
  async login({ commit }, data) {
    try {
      const response = await api.post('/auth/login', data)
      const user = dottie.get(response, 'data.account', null)
      commit('userLoggedIn', { user })
    } catch (e) {
      commit('loginFailed')
    }
  },

  async logout({ commit }) {
    try {
      await api.get('/auth/logout')
    } catch (e) {}
    commit('userLoggedOut')
  },

  async verifyUser({ commit, state }) {
    if (state.validUser) return state.validUser
    try {
      const response = await api.get('/auth/currentUser')
      const user = dottie.get(response, 'data.account', null)
      commit('verified', { user })
      return true
    } catch (e) {
      commit('verificationFailed')
      return false
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
